import React, { useEffect, useRef, useState } from 'react';
import classes from './CarouselBlock.module.css';

export default function CarouselThumbnails({ embla, images }) {
  const [active, setActive] = useState(0);
  const buttons = useRef([]);
  const list = useRef(null);
  useEffect(() => {
    if (!embla) return undefined;
    const select = () => setActive(embla.selectedScrollSnap());
    select();
    embla.on('select', select);
    embla.on('reInit', select);
    return () => { embla.off('select', select); embla.off('reInit', select); };
  }, [embla]);
  useEffect(() => {
    const button = buttons.current[active];
    const viewport = list.current;
    if (!button || !viewport) return;
    const left = button.offsetLeft - viewport.offsetLeft;
    const right = left + button.offsetWidth;
    if (left < viewport.scrollLeft) viewport.scrollLeft = left;
    else if (right > viewport.scrollLeft + viewport.clientWidth) viewport.scrollLeft = right - viewport.clientWidth;
  }, [active]);
  return (
    <div ref={list} className={classes.thumbnails} role="group" aria-label="Navigation par miniatures">
      {images.map((image, index) => (
        <button
          key={index}
          ref={(button) => { buttons.current[index] = button; }}
          type="button"
          className={classes.thumbnail}
          aria-label={`Afficher ${image.label}`}
          aria-current={active === index ? 'true' : undefined}
          onClick={() => embla?.scrollTo(index)}
        >
          <img src={image.src} srcSet={image.srcSet || undefined} sizes="72px" alt="" loading="lazy" />
        </button>
      ))}
    </div>
  );
}
